module.exports = __webpack_public_path__ + "static/img/gggggg_18.bd3c618.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_18.png
// module id = Lgyl
// module chunks = 1